import { Navigate, Route, Routes } from 'react-router-dom';
import Categories from '../Categories/Categories';
import CategoryCreatePage from '../Categories/Category';
import ResourceListPage from '../ResourceList';
import ResourceCreatePage from '../ResourceList/ResourceCreate';
import ResourcePdfViewer from '../ResourceList/ResourcePdfViewer';
import React from 'react';
import ResourceCardsView from '../ResourceList/ResourceCardsView';
import CategoryDisplay from '../Categories/CategoryDisplay';

export const AlignAdminRoutes = () => {
	return (
		<Routes>
			<Route
				path="categories"
				element={
					<ProtectedRoute>
						<Categories />
					</ProtectedRoute>
				}
			/>

			<Route
				path="categories/create"
				element={
					<ProtectedRoute>
						<CategoryCreatePage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="categories/edit/:categoryId"
				element={
					<ProtectedRoute>
						<CategoryCreatePage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources"
				element={
					<ProtectedRoute>
						<ResourceListPage admin={true} />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/edit/:resourceId"
				element={
					<ProtectedRoute>
						<ResourceCreatePage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/create"
				element={
					<ProtectedRoute>
						<ResourceCreatePage />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/edit/:resourceId/pdf/:pdfId"
				element={
					<ProtectedRoute>
						<ResourcePdfViewer />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/category/:categoryId/:type"
				element={
					<ProtectedRoute>
						<CategoryDisplay />
					</ProtectedRoute>
				}
			/>

			<Route path="/" element={<Categories />} />
		</Routes>
	);
};

const ProtectedRoute = ({ children }) => {
	if (!window.sessionStorage.getItem('accessToken')) {
		return <Navigate to="blank" />;
	}
	return children;
};
